import { useState, useEffect } from 'react';

/**
 * Custom hook to manage band component logic
 * Shared between BandComponent (desktop) and BandComponentMobile
 */
export const useBandLogic = (data, onQtyChange) => {
  const [musicians, setMusiciansData] = useState([]);
  const [vocalists, setVocalists] = useState([]);

  useEffect(() => {
    if (data !== undefined) {
      // Filter musicians data
      const musiciansFiltered = data?.filter(
        (item) => item.type === 0 || item.type === 5
      );
      setMusiciansData(musiciansFiltered);

      // Filter vocalists data
      const vocalistsFiltered = data?.filter((item) => item.type === 1);
      setVocalists(vocalistsFiltered);
    }
  }, [data]);

  const handleQtyChange = (id, value, itemData) => {
    // Determine the object type based on itemData.type
    const object = itemData.type === 1 ? 'vocalists' : 'musicians';
    // Call parent onQtyChange with correct parameter order: (value, id, object, bandType)
    onQtyChange && onQtyChange(value, id, object, itemData.type);
  };

  return {
    musicians,
    vocalists,
    handleQtyChange,
  };
};